<div class="wrapper">
    <div class="header">
        <app-section-header [title]="'Contacts'" [iconName]="'contacts'" [actionsTemplate]="actionsTemplate">
            <ng-template #actionsTemplate>
                <div class="actions">
                    <button class="primary-btn" (click)="onCreateNewContactClicked()">
                        <span class="icon" [innerHTML]="plusIcon"></span> New Contact
                    </button>
                </div>
            </ng-template>
        </app-section-header>

        <div class="filters">
            <app-contacts-filters></app-contacts-filters>
        </div>
    </div>

    <div class="list">
        <app-contacts-list></app-contacts-list>
    </div>
</div>
